export default __webpack_public_path__ + "static/media/tubigon.f87a4cf9.jpg";